import { render, staticRenderFns } from "./AttendingPhysician.vue?vue&type=template&id=7581221d&scoped=true"
import script from "./AttendingPhysician.vue?vue&type=script&lang=js"
export * from "./AttendingPhysician.vue?vue&type=script&lang=js"
import style0 from "./AttendingPhysician.vue?vue&type=style&index=0&id=7581221d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7581221d",
  null
  
)

export default component.exports